import { render, staticRenderFns } from "./iMenu.vue?vue&type=template&id=1d95577a&scoped=true&"
import script from "./iMenu.vue?vue&type=script&lang=js&"
export * from "./iMenu.vue?vue&type=script&lang=js&"
import style0 from "./iMenu.vue?vue&type=style&index=0&id=1d95577a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95577a",
  null
  
)

export default component.exports